module.exports = require("core-js-pure/stable/instance/index-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/index-of.js
// module id = 594
// module chunks = 0